"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConfig = void 0;
var ClickBusting_1 = require("./ClickBusting");
var setClickBusting = function (config) {
    if (!config.suppressClickBustingClassName) {
        return;
    }
    ClickBusting_1.ClickBustingConfig.suppressionClassName = config.suppressClickBustingClassName;
};
var setConfig = function (config) {
    setClickBusting(config);
};
exports.setConfig = setConfig;
//# sourceMappingURL=SharedWidgets.js.map